<template>
  <div class="text-center mt-2">
    <span
      class="btn-footer"
      @click="cancel()"
    >
      {{ $t('label.cancel') }}
    </span>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'

export default {
  name: 'Cancel',

  methods: {
    cancel () {
      if (!window.opener) {
        EventBus.$emit('returnToMerchant', true)
      } else {
        window.opener.childSrcWindow.close()
      }
    }
  }
}
</script>
